module.exports = __webpack_public_path__ + "img/bian_icon.fe1fba21.svg";